import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { HiOutlineLifebuoy } from 'react-icons/hi2';
import SupportDialog from '@/components/common/SupportDialog';
import { Fab } from './SupportButton.styled';

export default function SupportButton() {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);

  return (
    <>
      <Fab
        type="button"
        aria-label={t('support.buttonLabel')}
        title={t('support.buttonLabel')}
        onClick={() => setOpen(true)}
      >
        <HiOutlineLifebuoy size="1.5rem" />
      </Fab>
      <SupportDialog open={open} onClose={() => setOpen(false)} />
    </>
  );
}
